// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"84a9b32f","191":"1cc796f1","282":"59de7de8","356":"61b3754a","453":"77b83518","569":"1b10474b","629":"18b493a0","656":"30acd18a","736":"88440920","754":"b5d641fb","840":"30fb19e2","866":"b0a2d273","900":"51944474","902":"ad2e7c47","945":"3440a61f"}[chunkId] + ".chunk.js";
};